export const mergeByProp = (prop, a = [], b = [], rulesFn, opts = {}) => {
  const propList = Array.isArray(prop) ? prop : [prop];
  const compareProps = (obj1, obj2) => propList.every((p) => obj1?.[p] === obj2?.[p]);

  if (opts?.keepPosition) {
    const keyFor = (item = {}) => propList.map((p) => item?.[p] ?? '__undefined__').join('::');
    const incomingByKey = new Map((b || []).map((item) => [keyFor(item), item]));
    const seenKeys = new Set();

    const merged = (a || []).map((current) => {
      const key = keyFor(current);
      seenKeys.add(key);
      if (!incomingByKey.has(key)) {
        return current;
      }
      const incoming = incomingByKey.get(key);
      return typeof rulesFn === 'function' ? rulesFn(current, incoming) : incoming;
    });

    const appended = (b || []).filter((item) => {
      const key = keyFor(item);
      if (seenKeys.has(key)) {
        return false;
      }
      seenKeys.add(key);
      return true;
    });

    return [...merged, ...appended];
  }

  if (typeof rulesFn !== 'function') {
    return [...a?.filter((n) => !b?.find((o) => compareProps(o, n))), ...b];
  }

  const uniqueA = a.filter((n) => !b?.find((o) => compareProps(o, n)));
  const uniqueB = b.filter((n) => !a?.find((o) => compareProps(o, n)));
  const merged = a
    .filter((n) => !!b?.find((o) => compareProps(o, n)))
    .map((aInstance) => {
      const bInstance = b?.find((o) => compareProps(o, aInstance));
      return rulesFn(aInstance, bInstance);
    });

  return [...uniqueA, ...uniqueB, ...merged];
};
